import { useEffect, useState } from "react"
import { useAppSelector } from "../app/hooks";

const useIsPFA = () => {
  const {user} = useAppSelector(state => state.auth);
  const [isPFA, setIsPFA] = useState(false);
  useEffect(() => {
    setIsPFA(user?.role.toLowerCase() === "pfa" || user?.PENS_SCOPE?.toLowerCase() === 'pfa');
  }, [user]);
  return isPFA;
}

export default useIsPFA;
